import { PureComponent } from "react";

import { type IHeaderCellProps } from "./HeaderCell.js";

export interface ICheckboxHeaderCellProps extends IHeaderCellProps {
  onChange: (selected: boolean) => void;
  defaultChecked: boolean;
  uniqueGridIdentifier: string;
  setCheckboxRef: (component: CheckboxHeaderCell) => void;
}

export interface ICheckboxHeaderCellState {
  checked: boolean;
}

export default class CheckboxHeaderCell extends PureComponent<ICheckboxHeaderCellProps, ICheckboxHeaderCellState> {
  constructor(props: ICheckboxHeaderCellProps) {
    super(props);
    this.state = {
      checked: props.defaultChecked,
    };
  }

  componentDidMount() {
    this.props.setCheckboxRef(this);
  }

  setSelected = (selected: boolean) => {
    if (this.state.checked !== selected) {
      this.setState({
        checked: selected,
      });
    }
  };

  handleClick = () => {
    const newCheckedState = !this.state.checked;
    this.setSelected(newCheckedState);
    this.props.onChange(newCheckedState);
  };

  render() {
    const checkboxId = `headerCheckbox_${this.props.uniqueGridIdentifier}`;
    const checked: boolean = this.state.checked === true; // for some reason this is necessary to prevent the following Warning message in the console:
    // " A component is changing a controlled input of type checkbox to be uncontrolled [...]"

    return (
      <div className="checkbox" style={{ paddingLeft: 5 }} data-testid={"grid-select-all"}>
        <input type="checkbox" id={checkboxId} checked={checked} onChange={this.handleClick} data-checked={checked} />
        <label htmlFor={checkboxId}></label>
      </div>
    );
  }
}
